<template>
  <div class="preloader">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: "Loader"
};
</script>

<style scoped lang="scss">
.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;

  .loader {
    display: inline-block;
    position: relative;
    width: 9.375rem;
    height: 9.375rem;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: #9370db;
    animation: spin 2s linear infinite;
    left: 50%;
    top: 50%;
    margin: -4.7rem 0 0 -4.7rem;

    &::before,
    &::after {
      content: " ";
      position: absolute;
      border-radius: 50%;
      border: 3px solid transparent;
    }

    &::before {
      top: 5px;
      left: 5px;
      right: 5px;
      bottom: 5px;
      border-top-color: #ba55d3;
      animation: spin 3s linear infinite;
    }

    &::after {
      top: 15px;
      left: 15px;
      right: 15px;
      bottom: 15px;
      border-top-color: #f56767;
      animation: spin 1.5s linear infinite;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
